import { render, staticRenderFns } from "./Aloite.vue?vue&type=template&id=14c2f12e&scoped=true"
import script from "./Aloite.vue?vue&type=script&lang=js"
export * from "./Aloite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c2f12e",
  null
  
)

export default component.exports